import React, { Component } from "react";
import { Button } from "@/components/ui/button";
import AnimatedBackground from "@/components/AnimatedBackground";

export class ErrorBoundary extends Component<
    { children: React.ReactNode },
    { hasError: boolean; error: Error | null }
> {
    constructor(props: { children: React.ReactNode }) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error: Error) {
        return { hasError: true, error };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        console.error('Board component error:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
                    <AnimatedBackground />
                    <div className="relative z-10 text-center">
                        <div className="text-lg text-red-400 mb-4">Something went wrong</div>
                        <div className="text-sm text-slate-400 mb-4">
                            {this.state.error?.message || 'An unexpected error occurred'}
                        </div>
                        <Button
                            onClick={() => window.location.reload()}
                            className="bg-indigo-500 hover:bg-indigo-600 text-white"
                        >
                            Retry
                        </Button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}
